// extracted by mini-css-extract-plugin
module.exports = {"Description":"Description_Description__2RWNc","threeLines":"Description_threeLines__3ajWu","twoLines":"Description_twoLines__2HGU6","full":"Description_full__TEV61"};